import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';

export const addImageDestinationLocation = (imageDestinationLocation) => {
    return asyncActionCreator(types.IMAGE_DESTINATION_LOCATION_ADDITION_UPDATED, serverApi.addImageDestinationLocation(imageDestinationLocation),
        json => ({ ...imageDestinationLocation, id: json }));
};

export function requestImageDestinationLocationValidation(validationRequest) {
    return asyncActionCreator(types.IMAGE_LOCATION_VALIDATION_REQUESTED, 
        serverApi.requestImageDestinationLocationValidation(validationRequest), json => json);
};


// WEBPACK FOOTER //
// ./src/js/actions/imageLocationActionCreators.js